import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from './components/Login';
import { BrowserRouter as Router, Route, Link, browserHistory } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import apiFetch from"./utils/apiFetch";
import {Redirect, withRouter} from "react-router";
import { GlobalHistory } from './history';
import getHistory from './history'
import NavbarComponent from "./components/NavbarComponent";
import AlbumAdd from "./components/AlbumAdd";
import Settings from "./components/Settings";
import Logout from "./components/Logout";
import Statistics from "./components/Statistics";
import AlbumEdit from "./components/AlbumEdit";
import Covers from "./components/Covers";
import MyAlbum from "./components/MyAlbum";
import UserLogin from "./components/UserLogin";
import AlbumInfo from "./components/AlbumInfo";


class App extends Component {

    constructor(props) {
        super(props)
        this.checkLogin()
        this.state = {
            need_login: false,
            is_user: true
        }
    }

    checkLogin = () => {

        apiFetch('auth.check', {
            login: localStorage.getItem('login'),
            password: localStorage.getItem('password')
        }).then((result) => {
            console.log(result);
            if (!result.success) {
                this.setState({need_login: true});
                //window.location.replace("/auth");
            } else {
                this.setState({need_login: false, is_user: result.is_user});
                console.log('auth is okey')
            }
        })

    }


    tryLogin = (login, password) => {
        localStorage.setItem('login', login);
        localStorage.setItem('password', password);
        this.checkLogin()

    }

    render() {
        const WrappedNavbarComponent = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<NavbarComponent {...props} app={this} />);
        };

        const WrappedUserLogin = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<UserLogin {...props} app={this} />);
        };

        const WrappedLogin = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<Login {...props} app={this} />);
        };

        const WrappedDashboard = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<Dashboard {...props} app={this} />);
        };

        const WrappedAlbumAdd = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<AlbumAdd {...props} app={this} />);
        };

        const WrappedAlbumEdit = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<AlbumEdit {...props} app={this} />);
        };
        const WrappedSettings = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<Settings {...props} app={this} />);
        };
        const WrappedStats = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<Statistics {...props} app={this} />);
        };
        const WrappedCovers = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<Covers {...props} app={this} />);
        };

        const WrappedAlbumInfo = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<AlbumInfo {...props} app={this} />);
        };

        const WrappedMyAlbum = (props) => {
            // Конструкция "{...props}" нужна, чтобы не потерять
            // параметры, переданные от компонента Route
            return (<MyAlbum {...props} app={this} />);
        };
            const MainPage = (this.state.is_user) ? WrappedMyAlbum : WrappedDashboard;


        return (
        <React.Fragment>
            <Router history={ browserHistory }>
                <WrappedNavbarComponent/>
                {this.state.need_login ?
                    <React.Fragment>
                        <Route path="/" component={WrappedUserLogin}/>
                        <Route path="/auth" component={WrappedLogin}/>
                    </React.Fragment> :
                    <React.Fragment>
                        <Route exact path="/" component={MainPage}/>
                        <Route path="/login" component={WrappedUserLogin}/>
                        <Route path="/auth" component={WrappedLogin}/>
                        <Route path="/dashboard" component={WrappedDashboard}/>
                        <Route path="/album/add" component={WrappedAlbumAdd}/>
                        <Route path="/album/edit/:albumId" component={WrappedAlbumEdit}/>
                        <Route path="/settings" component={WrappedSettings}/>
                        <Route path="/stats" component={WrappedStats}/>
                        <Route path="/album/info/:albumId" component={WrappedAlbumInfo}/>
                        <Route path="/covers" component={WrappedCovers}/>
                        <Route path="/my" component={WrappedMyAlbum}/>
                        <Route path="/logout" component={Logout}/>
                    </React.Fragment>
                }
            </Router>
        </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js